(function () {
  ui.on(ui.GlobalEvents.LOGOUT_HASH_NOTIFICATION, function () {
    $('.ui-js-logout-modal').modal('show');
  });
}).call(this);
